import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { logout, logoutAll } from '../service/authService';

interface LogoutButtonProps {
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'inherit' | 'primary' | 'secondary' | 'default';
  size?: 'small' | 'medium' | 'large';
  logoutAllDevices?: boolean;
  className?: string;
  onLogout?: () => void;
  iconOnly?: boolean;
  compact?: boolean;
}

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    minWidth: 'auto',
    fontSize: '0.875rem',
  },
  compactButton: {
    margin: 0,
    padding: theme.spacing(1, 2),
    minWidth: 'auto',
    fontSize: '0.875rem',
  },
  icon: {
    fontSize: '1.2rem',
    marginRight: theme.spacing(0.5),
  },
  iconButton: {
    padding: theme.spacing(0.5),
  }
}));

const LogoutButton: React.FC<LogoutButtonProps> = ({
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  logoutAllDevices = false,
  className,
  onLogout,
  iconOnly = false,
  compact = false,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    if (logoutAllDevices) {
      await logoutAll(dispatch);
    } else {
      await logout(dispatch);
    }
    // Redirect to login page after logout
    onLogout?.();
    window.location.href = '/';
  };

  if (iconOnly) {
    // IconButton only supports 'small' or 'medium' sizes
    const iconButtonSize = size === 'large' ? 'medium' : size;
    
    return (
      <IconButton
        color={color}
        size={iconButtonSize}
        className={`${classes.iconButton} ${className}`}
        onClick={handleLogout}
        aria-label="logout"
      >
        <ExitToAppIcon fontSize="inherit" />
      </IconButton>
    );
  }

  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      className={`${compact ? classes.compactButton : classes.button} ${className}`}
      onClick={handleLogout}
      startIcon={<ExitToAppIcon className={classes.icon} />}
    >
      {logoutAllDevices ? 'Logout from all devices' : 'Logout'}
    </Button>
  );
};

export default LogoutButton; 